import Skeleton from '@trackman/web-shared-components/components/LoadingPlaceholder/Skeleton';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  gap: 40px;
  margin-top: 5px;
`;

const LeftSide = styled.div`
  display: flex;
  gap: 8px;
`;

export const ControlsSkeleton = () => {
  return (
    <Wrapper>
      <LeftSide>
        <Skeleton variant='rectangular' width={150} height={32} />
        <Skeleton variant='rectangular' width={40} height={32} />
      </LeftSide>
      <Skeleton variant='rectangular' width={150} height={32} />
    </Wrapper>
  );
};
